
// Soft UI Dashboard React base styles
import colors from "assets/theme/base/colors";

// Soft UI Dashboard React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { transparent, dark } = colors;

const select = {
  styleOverrides: {
    select: {
      display: "flex !important",
      alignItems: "center",
      width: "100% !important",
      minHeight: pxToRem(40),
      padding: `${pxToRem(8)} ${pxToRem(36)} ${pxToRem(8)} ${pxToRem(12)} !important`,
      cursor: "pointer",

      "& .Mui-selected": {
        backgroundColor: transparent.main,
      },
    },

    selectMenu: {
      background: "none",
      height: "none",
      minHeight: "none",
      overflow: "unset",
    },

    icon: {
      color: dark.main,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      right: pxToRem(6),
      width: pxToRem(24),
      height: pxToRem(24),
      top: "calc(50% - 12px)",
      pointerEvents: "none",
    },
  },
};

export default select;
